import { isIOS } from "./installPass";

// Guide illustré « Ajouter à l'écran d'accueil » (iPhone / Android / autre).
export function InstallGuide({ onClose }) {
  const ios = isIOS();
  const steps = ios
    ? [
        ["Touche le bouton Partager", "L'icône carré avec une flèche vers le haut, en bas de Safari.", "⬆️"],
        ["Choisis « Sur l'écran d'accueil »", "Fais défiler la liste si tu ne le vois pas tout de suite.", "➕"],
        ["Touche « Ajouter »", "L'icône « Carte Impact » apparaît sur ton écran d'accueil.", "✅"],
      ]
    : [
        ["Ouvre le menu ⋮", "En haut à droite de Chrome (ou Samsung Internet).", "⋮"],
        ["Choisis « Ajouter à l'écran d'accueil » ou « Installer »", "Le nom proposé est « Carte Impact ».", "➕"],
        ["Confirme", "L'icône apparaît sur ton écran d'accueil et s'ouvre plein écran.", "✅"],
      ];
  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-end sm:items-center justify-center p-4" onClick={onClose} data-testid="install-guide-modal">
      <div onClick={(e) => e.stopPropagation()} className="w-full max-w-sm rounded-2xl border border-amber-900/50 bg-zinc-950 p-5 shadow-2xl">
        <div className="text-xs uppercase tracking-widest text-amber-500/80">{ios ? "iPhone · Safari" : "Android · Chrome"}</div>
        <h2 className="text-lg font-bold text-amber-200 mt-1">Ajouter la carte à ton écran d'accueil</h2>
        <p className="text-xs text-zinc-400 mt-1">Gratuit, en 10 secondes. La carte s'ouvre ensuite comme une app, même sans réseau.</p>
        <ol className="mt-4 space-y-3">
          {steps.map(([t, d, icon], i) => (
            <li key={i} className="flex gap-3 items-start" data-testid={`install-step-${i + 1}`}>
              <span className="w-9 h-9 rounded-full bg-amber-900/40 border border-amber-700 flex items-center justify-center text-lg shrink-0">{icon}</span>
              <div>
                <div className="text-sm font-semibold text-zinc-100">{i + 1}. {t}</div>
                <div className="text-xs text-zinc-400">{d}</div>
              </div>
            </li>
          ))}
        </ol>
        {ios && (
          <p className="mt-4 text-[11px] text-zinc-500">Astuce : si tu es dans Messenger, Instagram ou Gmail, ouvre d'abord le lien dans Safari (menu ⋯ → « Ouvrir dans Safari »).</p>
        )}
        <button onClick={onClose} data-testid="install-guide-close"
          className="mt-5 w-full py-2.5 rounded-xl bg-amber-600 hover:bg-amber-500 text-zinc-950 font-bold text-sm">Compris</button>
      </div>
    </div>
  );
}
